<template>
  <div class="bg-white shadow rounded px-3 pt-3 pb-5 border border-white">
    <div class="flex justify-between">
      <div>
        <p class="text-gray-700 font-semibold font-sans tracking-wide text-sm">{{ limitTextTask(task.title) }}</p>
        <small>{{ limitTextTask(task.description) }}</small>
      </div>
      <a-tooltip placement="left">
        <template slot="title">
          <span>Edit</span>
        </template>
        <feather-icon icon="Edit2Icon" svg-classes="text-success cursor-pointer" @click="editKanbanItem(task)"></feather-icon>
      </a-tooltip>
    </div>
    <div class="flex mt-4 justify-between items-center">
      <span class="text-sm text-gray-600">{{setDateFormat(task.due_date)}}</span>
      <span class="text-sm text-gray-600">
        <ATag :color="statusTask(task.status).split(',')[0]">{{ statusTask(task.status).split(',')[1] }}</ATag>
      </span>
    </div>
  </div>
</template>
<script>
import Badge from "./Badge.vue";
import moment from 'moment'
import mixin from "../../mixin/mixin"
export default {
  components: {
    Badge
  },
  mixins:[mixin],
  props: {
    task: {
      type: Object,
      default: () => ({})
    }
  },
  methods: {
    due_date(date){
      return date ? moment(date).format('YYYY-MM-DD') : '__'
    },
    statusTask(status){
      if(status === 1)
        return 'blue,Pending'
      else if(status === 2)
        return 'orange,Progress'
      else if(status === 3)
        return 'purple,Review'
      else
        return 'green,Complete'
    },
    editKanbanItem(task){
      this.$emit('editKanbanItem',task)
    },
  }
};
</script>
